module.exports = __webpack_public_path__ + "static/img_5079-607408eca77ab89d546e4bcef22100a0.webp";